import { PROCESS_FEATURE, StateUtils } from '@spartacus/core';
import { UserSignUp } from '@spartacus/user/profile/root';
import {
  DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS_ID
} from '../custom-document-identifier-validator-state';

export enum CustomDocumentIdentifierValidatorActionTypes {
  DOCUMENT_IDENTIFIER_VALIDATOR = '[User] Document Identifier Validator',
  DOCUMENT_IDENTIFIER_VALIDATOR_FAIL = '[User] Document Identifier Validator Fail',
  DOCUMENT_IDENTIFIER_VALIDATOR_SUCCESS = '[User] Document Identifier Validator Success',
  RESET_DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS = '[User] Reset Document Identifier Validator Process',
}
export class DocumentIdentifierValidator extends StateUtils.EntityLoadAction {
  readonly type = CustomDocumentIdentifierValidatorActionTypes.DOCUMENT_IDENTIFIER_VALIDATOR;
  constructor(public payload: UserSignUp) {
    super(PROCESS_FEATURE, DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS_ID);
  }
}

export class DocumentIdentifierValidatorFail extends StateUtils.EntityFailAction {
  readonly type = CustomDocumentIdentifierValidatorActionTypes.DOCUMENT_IDENTIFIER_VALIDATOR_FAIL;
  constructor(public payload: any) {
    super(PROCESS_FEATURE, DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS_ID, payload);
  }
}

export class DocumentIdentifierValidatorSuccess extends StateUtils.EntitySuccessAction {
  readonly type = CustomDocumentIdentifierValidatorActionTypes.DOCUMENT_IDENTIFIER_VALIDATOR_SUCCESS;
  constructor() {
    super(PROCESS_FEATURE, DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS_ID);
  }
}

export class ResetDocumentIdentifierValidatorProcess extends StateUtils.EntityLoaderResetAction {
  readonly type = CustomDocumentIdentifierValidatorActionTypes.RESET_DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS;
  constructor() {
    super(PROCESS_FEATURE, DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS_ID);
  }
}
// action types
export type CustomDocumentIdentifierValidatorListActions =
  | DocumentIdentifierValidator
  | DocumentIdentifierValidatorFail
  | DocumentIdentifierValidatorSuccess
  | ResetDocumentIdentifierValidatorProcess;

